<template>
  <div class="tableMask">
    <div class="anList examTable">
      <div class="antitle tableTitle">

        <h3>本试题卷使用的税率表如下：<span style="font-size:14px;font-weight: normal">注：提供税率表旨在方便学员日常练习使用。</span></h3>
        <p>
          <a href="javascript:void(0)"
             @click="changeTable(1)"
             :class="isTable1?'on':''">常用消费税税率表</a>、
          <a href="javascript:void(0)"
             @click="changeTable(2)"
             :class="isTable2?'on':''">个人所得税预扣率表一</a>、
          <a href="javascript:void(0)"
             @click="changeTable(3)"
             :class="isTable3?'on':''">个人所得税预扣率表二</a>、
          <a href="javascript:void(0)"
             @click="changeTable(4)"
             :class="isTable4?'on':''">按月换算后的综合所得税率表</a>、
          <a href="javascript:void(0)"
             @click="changeTable(5)"
             :class="isTable5?'on':''">经营所得个人所得税税率表</a>、
          <a href="javascript:void(0)"
             @click="changeTable(6)"
             :class="isTable6?'on':''">综合所得个人所得税税率表</a>
        </p>
      </div>
      <div class="mainTable">
        <table class="tax-law"
               v-show="isTable1"

               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="2"><b>常用消费税税率表</b></td>
          </tr>
          <tr>
            <th>税目</th>
            <th>税率</th>
          </tr>
          <tr>
            <td align="left">
              <p>一、烟</p>
              <p class="level1">1.卷烟</p>
              <p class="level2">（1）甲类卷烟</p>
              <p class="level2">（2）乙类卷烟</p>
              <p class="level2">（3）批发环节</p>
              <p class="level1">2.雪茄烟</p>
              <p class="level1">3.烟丝</p>
            </td>
            <td>
              <p>&nbsp; </p>
              <p>&nbsp; </p>
              <p>56%加0.003元/支</p>
              <p>36%加0.003元/支</p>
              <p>11%加0.005元/支</p>
              <p>36%</p>
              <p>30%</p>
            </td>
          </tr>
          <tr>
            <td align="left">
              <p>二、酒</p>
              <p class="level1">1.白酒</p>
              <p class="level1">2.黄酒</p>
              <p class="level1">3.啤酒</p>
              <p class="level2">（1）甲类啤酒</p>
              <p class="level2">（2）乙类啤酒</p>
              <p class="level1">4.其他酒</p>
            </td>
            <td>
              <p>&nbsp;</p>
              <p>20%加0.5元/500克（或者500毫升）</p>
              <p>240元/吨</p>
              <p>&nbsp;</p>
              <p>250元/吨</p>
              <p>220元/吨</p>
              <p>10%</p>
            </td>
          </tr>
        </table>
        <table v-show="isTable2"

               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="4"><b>个人所得税预扣率表一</b>
              <p>（居民个人工资、薪金所得预扣预缴适用）</p>
            </td>
          </tr>
          <tr>
            <th>级数</th>
            <th>累计预扣预缴应纳税所得额</th>
            <th>预扣率（%）</th>
            <th>速算扣除数</th>
          </tr>
          <tr>
            <td>1</td>
            <td align="left">不超过36000元的部分</td>
            <td>3</td>
            <td>0</td>
          </tr>
          <tr>
            <td>2</td>
            <td align="left">超过36000元至144000元的部分</td>
            <td>10</td>
            <td>2520</td>
          </tr>
          <tr>
            <td>3</td>
            <td align="left">超过144000元至300000元的部分</td>
            <td>20</td>
            <td>16920</td>
          </tr>
          <tr>
            <td>4</td>
            <td align="left">超过300000元至420000元的部分</td>
            <td>25</td>
            <td>31920</td>
          </tr>
          <tr>
            <td>5</td>
            <td align="left">超过420000元至660000元的部分</td>
            <td>30</td>
            <td>52920</td>
          </tr>
          <tr>
            <td>6</td>
            <td align="left">超过660000元至960000元的部分</td>
            <td>35</td>
            <td>85920</td>
          </tr>
          <tr>
            <td>7</td>
            <td align="left">超过960000元的部分</td>
            <td>45</td>
            <td>181920</td>
          </tr>
        </table>
        <table v-show="isTable3"

               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="4"><b>个人所得税预扣率表二</b>
              <p>（居民个人劳务报酬所得预扣预缴适用）</p>
            </td>
          </tr>
          <tr>
            <th>级数</th>
            <th>预扣预缴应纳税所得额</th>
            <th>预扣率（%）</th>
            <th>速算扣除数</th>
          </tr>
          <tr>
            <td>1</td>
            <td align="left">不超过20000元的</td>
            <td>20</td>
            <td>0</td>
          </tr>
          <tr>
            <td>2</td>
            <td align="left">超过20000元至50000元的部分</td>
            <td>30</td>
            <td>2000</td>
          </tr>
          <tr>
            <td>3</td>
            <td align="left">超过50000的部分</td>
            <td>40</td>
            <td>7000</td>
          </tr>
        </table>
        <table v-show="isTable4"

               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="4"><b>按月换算后的综合所得税率表</b></td>
          </tr>
          <tr>
            <th>级数</th>
            <th>全月应纳税所得额</th>
            <th>税率</th>
            <th>速算扣除数</th>
          </tr>
          <tr>
            <td>1</td>
            <td align="left">不超过3000元的</td>
            <td>3%</td>
            <td>0</td>
          </tr>
          <tr>
            <td>2</td>
            <td align="left">超过3000元至12000元的部分</td>
            <td>10%</td>
            <td>210</td>
          </tr>
          <tr>
            <td>3</td>
            <td align="left">超过12000元至25000元的部分</td>
            <td>20%</td>
            <td>1410</td>
          </tr>
          <tr>
            <td>4</td>
            <td align="left">超过25000元至35000元的部分</td>
            <td>25%</td>
            <td>2660</td>
          </tr>
          <tr>
            <td>5</td>
            <td align="left">超过35000元至55000元的部分</td>
            <td>30%</td>
            <td>4410</td>
          </tr>
          <tr>
            <td>6</td>
            <td align="left">超过55000元至80000元的部分</td>
            <td>35%</td>
            <td>7160</td>
          </tr>
          <tr>
            <td>7</td>
            <td align="left">超过80000元的部分</td>
            <td>45%</td>
            <td>15160</td>
          </tr>
        </table>
        <table v-show="isTable5"

               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="4"><b>经营所得个人所得税税率表</b></td>
          </tr>
          <tr>
            <th>级数</th>
            <th>全年应纳税所得额</th>
            <th>税率</th>
            <th>速算扣除数（元）</th>
          </tr>
          <tr>
            <td>1</td>
            <td align="left">不超过30000元的</td>
            <td>5</td>
            <td>0</td>
          </tr>
          <tr>
            <td>2</td>
            <td align="left">超过30000元至90000元的部分</td>
            <td>10</td>
            <td>1500</td>
          </tr>
          <tr>
            <td>3</td>
            <td align="left">超过90000元至300000元的部分</td>
            <td>20</td>
            <td>10500</td>
          </tr>
          <tr>
            <td>4</td>
            <td align="left">超过300000元至500000元的部分</td>
            <td>30</td>
            <td>40500</td>
          </tr>
          <tr>
            <td>5</td>
            <td align="left">超过500000元的部分</td>
            <td>35</td>
            <td>65500</td>
          </tr>
        </table>
        <table v-show="isTable6"
               cellpadding="0"
               cellspacing="0">
          <tr>
            <td colspan="4"><b>综合所得个人所得税税率表</b></td>
          </tr>
          <tr>
            <th>级数</th>
            <th>全年应纳税所得额</th>
            <th>预扣率（%）</th>
            <th>速算扣除数</th>
          </tr>
          <tr>
            <td>1</td>
            <td align="left">不超过36000元的部分</td>
            <td>3</td>
            <td>0</td>
          </tr>
          <tr>
            <td>2</td>
            <td align="left">超过36000元至144000元的部分</td>
            <td>10</td>
            <td>2520</td>
          </tr>
          <tr>
            <td>3</td>
            <td align="left">超过144000元至300000元的部分</td>
            <td>20</td>
            <td>16920</td>
          </tr>
          <tr>
            <td>4</td>
            <td align="left">超过300000元至420000元的部分</td>
            <td>25</td>
            <td>31920</td>
          </tr>
          <tr>
            <td>5</td>
            <td align="left">超过420000元至660000元的部分</td>
            <td>30</td>
            <td>52920</td>
          </tr>
          <tr>
            <td>6</td>
            <td align="left">超过660000元至960000元的部分</td>
            <td>35</td>
            <td>85920</td>
          </tr>
          <tr>
            <td>7</td>
            <td align="left">超过960000元的部分</td>
            <td>45</td>
            <td>181920</td>
          </tr>
        </table>
      </div>
      <div class="anfooter">
        <a href="javascript:void(0)"
           class="an"
           @click="closeTable">关闭</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'examTableTaxLaw',
  data() {
    return {
      isTable1: true,
      isTable2: false,
      isTable3: false,
      isTable4: false,
      isTable5: false,
      isTable6: false,
    }
  },
  methods: {
    closeTable() {
      this.$emit('toggleTable', false)
    },
    changeTable(num) {
      switch (num) {
        case 1:
          this.isTable1 = true
          this.isTable2 = false
          this.isTable3 = false
          this.isTable4 = false
          this.isTable5 = false
          this.isTable6 = false
          break
        case 2:
          this.isTable2 = true
          this.isTable1 = false
          this.isTable3 = false
          this.isTable4 = false
          this.isTable5 = false
          this.isTable6 = false
          break
        case 3:
          this.isTable3 = true
          this.isTable1 = false
          this.isTable2 = false
          this.isTable4 = false
          this.isTable5 = false
          this.isTable6 = false
          break
        case 4:
          this.isTable4 = true
          this.isTable1 = false
          this.isTable2 = false
          this.isTable3 = false
          this.isTable5 = false
          this.isTable6 = false
          break
        case 5:
          this.isTable5 = true
          this.isTable1 = false
          this.isTable2 = false
          this.isTable3 = false
          this.isTable4 = false
          this.isTable6 = false
          break
        case 6:
          this.isTable6 = true
          this.isTable1 = false
          this.isTable2 = false
          this.isTable3 = false
          this.isTable4 = false
          this.isTable5 = false
          break
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tax-law {
  p {
    margin-left: 10px;
    line-height: 20px;
    height: 20px;
  }

  .level1 {
    margin-left: 40px;
  }

  .level2 {
    margin-left: 50px;
  }
}
</style>

